import styled from "@emotion/styled";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { COLOR_GREY_5 } from "shared/theme/colors";

export const StyledTableCell = styled(TableCell)`
    border-right: 1px solid ${COLOR_GREY_5};
    border-bottom: none;
    padding: 8px;
    vertical-align: top;

    &:last-child {
        border-right: none;
    }
`;

export const StyledTableHeadCell = styled(TableCell)`
    border-right: 1px solid ${COLOR_GREY_5};
    border-bottom: none;
    padding: 12px;

    &:last-child {
        border-right: none;
    }

    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 21px */
`;

export const StyledTableRow = styled(TableRow)`
    border-bottom: 1px solid ${COLOR_GREY_5};

    &:last-child {
        border-bottom: none;
    }
`;

export const StyledTableHead = styled(TableHead)`
    border-bottom: 1px solid ${COLOR_GREY_5};
`;
